import { useCallback } from "react";

import useAccountMetadata from "./useAccountMetadata";
import useCurrentProject from "./use-project";
import { LoadedDestinationInfo } from "../types/global";
import { SaaSDestination } from "../destinations/destinations";
import {
  DestinationValidationResult,
  DestinationValidity,
  getDestinationValidity,
} from "../destinations/validation";

export default function useDestinationValidity(): (
  configuredDest: LoadedDestinationInfo,
  destination: SaaSDestination
) => DestinationValidationResult {
  const accountMetadata = useAccountMetadata();
  const currentProject = useCurrentProject();

  return useCallback(
    (configuredDest: LoadedDestinationInfo, destination: SaaSDestination) => {
      if (!accountMetadata || !currentProject.loaded) {
        return {
          validity: DestinationValidity.valid,
        } as DestinationValidationResult;
      }

      return getDestinationValidity(
        accountMetadata,
        currentProject,
        configuredDest,
        destination
      );
    },
    [accountMetadata, currentProject]
  );
}
